export default __webpack_public_path__ + "static/media/treatments.00d12bac.jpg";